/* */
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  var arr_mb = [
    			'Alyssa','Mariana','Susanne','Nadia Uddin','Evie','Molly S.','Angie','Pheng T.','Lauren B.','Rachel',
                'Rachel','Jessica','Julia','Eileen','Christina','Michael Hooper','Jo','Sue','Lissa Rose','Steve C',
    			'Michael H.','Chris','Vicky R.','Heather','Vita','Joanna','Alexia W.','Elizabeth','Hannah','Kellie',
    			'Kelly','James','Natalie','Joe','Michael K.',
    			'Serena','Jennifer','Lindsey','Tiffany','Shayla','Nicole.M','KC','Melly',
				'Kate','Natalie','Kayla J. ','Louie','Jennie','Sue','Pam',
    			'Christina','Louie','Hee','Lui',
    			'Sarah','Kayla J.'
    
               ];
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  //console.log( jQuery.inArray("John", arr_mb) );  // -1
  //console.log( jQuery.inArray("Alyssa", arr_mb) );  // 0
  //console.log( jQuery.inArray("Mariana", arr_mb) );  // 1

  
  var hot = (function bar() {
    
      setTimeout(function() {
        
        if($('.yotpo-user-name').length > 0) {

            $('.yotpo-user-name').each(function (index, item) {
              var yotpo_user_name = $(this).html();
              
              if(yotpo_user_name != '') {
                if(! $(this).next().hasClass('label-with-tooltip')) {
                  
                  if(jQuery.inArray(yotpo_user_name, arr_mb) > -1) {
                    $(this).after('<div class="label-with-tooltip pull-left" aria-level="3"><span class="y-label yotpo-user-title yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip" aria-describedby="">Verified Buyer</span></div>');
                  }
                }
                else {
                  hot();
                }
              }
            });
          
        }
        else {
          hot();
        }
        
     }, 100);
    
     return bar;
  })();   // hot

  hot();  // hot
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
